export default __webpack_public_path__ + "static/media/dont_quit_mobile_2.bbbff82b.png";